import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import DateService from '../../../services/DateService';
import TapIcon from '../../../services/TapIcon';
import api from '../../../services/api';
import { HRM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';
import WorklogDocument from './WorklogDocument';

const WorklogDetail = ({ worklogId, onClose }) => {
    const access_token              =   useSelector(state => state.auth.access_token);
    const [loading, setLoading]     =   useState(true);
    const [data, setData]           =   useState(null);

    useEffect(() => {
        if (worklogId) {
            loadWorklogDetail();
        }
    }, [worklogId]);

    const loadWorklogDetail = async () => {
        setLoading(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + access_token };
            const response = await api.server2Api.get(`${HRM_API_BASE_URL_2}/work_log/detail/${worklogId}`, { headers });
            setData(response.data);
        } catch (error) {
            toast.error('Failed to load worklog details');
        } finally {
            setLoading(false);
        }
    };

    const formatSeconds = (seconds) => {
        if (!seconds && seconds !== 0) return '-';
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (hrs > 0) {
            return `${hrs}h ${mins}m ${secs}s`;
        } else if (mins > 0) {
            return `${mins}m ${secs}s`;
        } else {
            return `${secs}s`;
        }
    };

    const formatDateTime = (dateTime) => {
        if (!dateTime) return '-';
        return DateService.dateTimeFormat(dateTime);
    };

    const formatDate = (date) => {
        if (!date) return '-';
        return DateService.dateFormat(date);
    };

    if (loading) {
        return (
            <div className='text-center p-5'>
                <Loader />
            </div>
        );
    }

    return (
        <>
            <div className="mb-5 mt-2" style={{ overflowY: "scroll", maxHeight: "500px" }}>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="tab_content_wrapper">
                        <span className="content_heading">Worklog Details</span>
                    </div>
                </div>
                {data &&
                    <>
                        <div className="pe-3">
                            <table className="table table-hover table-bordered px-4 bg-white mb-0 ">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "33%" }} >Employee Name</td>
                                        <th colSpan={2}>{data.employee?.name || '-'}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Site</td>
                                        <th colSpan={2}>{data.employee?.site_name || '-'}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Work Log Type</td>
                                        <th colSpan={2}>{data.work_log_type?.name || '-'}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Start Time</td>
                                        <th colSpan={2}> {formatDateTime(data.start_time)}
                                            {data.start_date && data.start_date !== data.start_time?.split(' ')[0] && (
                                                <small className="text-muted d-block">Date: {formatDate(data.start_date)}</small>
                                            )}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >End Time</td>
                                        <th colSpan={2}> {formatDateTime(data.end_time)}
                                            {data.end_date && data.end_date !== data.end_time?.split(' ')[0] && (
                                                <small className="text-muted d-block">Date: {formatDate(data.end_date)}</small>
                                            )}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Duration</td>
                                        <th colSpan={2}> {formatSeconds(data.log_seconds)} </th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Notes</td>
                                        <th colSpan={2}> {data.notes || '-'} </th>
                                    </tr>
                                    {data.asset && (
                                        <tr>
                                            <td style={{ width: "33%" }} >Asset</td>
                                            <th colSpan={2}> {data.asset?.name || '-'}
                                            </th>
                                        </tr>)}
                                    {data.workstation && (
                                        <tr>
                                            <td style={{ width: "33%" }} >Workstation</td>
                                            <th colSpan={2}> {data.workstation?.name || '-'}
                                            </th>
                                        </tr>)}
                                    {data.ticket && (
                                        <tr>
                                            <td style={{ width: "33%" }} >Ticket Header</td>
                                            <th colSpan={2}> {data.ticket?.header || '-'}
                                            </th>
                                        </tr>)}
                                         {data.ticket && (
                                        <tr>
                                            <td style={{ width: "33%" }} >Ticket ID</td>
                                            <th colSpan={2}> {data.ticket?.activity_id || '-'}
                                            </th>
                                        </tr>)}
                                </tbody>

                            </table>
                        </div>
                    {data.additional_attr && data.additional_attr.length > 0 && <>
                        <div className="tab_content_wrapper mt-4"> <span className="content_heading">Additional Attributes</span></div>
                        <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                            {data && <tbody>
                                {data.additional_attr && data.additional_attr.length > 0 ?
                                    data.additional_attr.map((attribute, index) => {
                                        return (<tr>
                                            <td style={{ width: "25%" }}>{attribute.name}</td>
                                            <th>{attribute.value ? attribute.value : "-"}</th>
                                        </tr>)
                                    })
                                    : null}
                            </tbody>}
                        </table>
                    </>}
                        <WorklogDocument worklogDetails={data} loadWorklogDetail={(id) => loadWorklogDetail(id)} />
                    </>
                }
            </div>

        </>
    );
};

export default WorklogDetail;